import { StatusCode, type ApiMsg } from "@/types"
import { API_WEB_FULLERETTE } from "@/config"

export async function verifyNumber(username: string, phoneNumber: string): Promise<StatusCode> {
    try {
        const body = new URLSearchParams({
            username,
            phoneNumber,
        })

        const response = await fetch(`${API_WEB_FULLERETTE}ValidaTelefonoUsuario`, {
            method: "POST",
            body,
        })

        return response.status as StatusCode
    } catch (error) {
        console.error(error)
        return StatusCode.FATAL_ERROR
    }
}

export async function verifyPassword(currentPassword: string, newPassword: string): Promise<{ status: StatusCode; message?: string }> {
    try {
        const body = new URLSearchParams({
            currentPassword,
            newPassword,
        })

        const response = await fetch(`${API_WEB_FULLERETTE}VerificaPass`, {
            method: "POST",
            body
        })

        let message: string | undefined

        const contentType = response.headers.get("content-type") ?? ""
        if (contentType.includes("application/json")) {
            const data = (await response.json()) as ApiMsg
            message = data.respuesta
        }


        return { status: response.status as StatusCode, message }

    } catch (error) {
        console.error(error)
        return { status: StatusCode.FATAL_ERROR, message: "No se pudo conectar al servidor" }
    }
}


export async function updatePassword(username: string, newPassword: string): Promise<{ status: StatusCode; message?: string }> {
    try {
        const body = new URLSearchParams({
            username,
            newPassword,
        })

        const response = await fetch(`${API_WEB_FULLERETTE}ActualizaPass`, {
            method: "POST",
            body,
        })

        let message: string | undefined

        const contentType = response.headers.get("content-type") ?? ""
        if (contentType.includes("application/json")) {
            const data = await response.json()
            message = data.mensaje
        }

        return { status: response.status as StatusCode, message }
    } catch (error) {
        console.error(error)
        return { status: StatusCode.FATAL_ERROR, message: "No se pudo conectar al servidor", }
    }
}
